import * as React from "react";
import axios from "axios";
import ColumnMenu from "../../../../Shared/GridComponents/ColumnMenu";
import { CellRender, GridNoRecord, MenuRender, StatusCell } from "../../../../Shared/GridComponents/CommonComponents";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { State, toODataString } from "@progress/kendo-data-query";
import { KendoFilter, NumberCell } from "../../../../ReusableComponents";
import { initialDataState } from "../../../../../HelperMethods";
import RowActions from "../../../../Shared/Workflow/RowActions";
import { CustomMenu, DefaultActions } from "./GlobalActions"
import { AuthRole, AuthRoleType } from "../../../../Shared/AppConstants";
import auth from "../../../../Auth";

export interface CandidateOwnershipWithShareProps {
    candidateId: any;
}

export interface CandidateOwnershipWithShareState {
    search: string;
    data: any;
    candidateId: string;
    dataState: any;
    showLoader?: boolean;
    totalCount?: number;
    showEndOwnershipModal?: boolean;
    totalCandidate?: any;
    isVendorRole: boolean;
    isClientRole: boolean;
}

class CandidateOwnershipWithShare extends React.Component<CandidateOwnershipWithShareProps, CandidateOwnershipWithShareState> {
    private userObj: any = JSON.parse(localStorage.getItem("user"));
    constructor(props: CandidateOwnershipWithShareProps) {
        super(props);
        this.state = {
            search: "",
            data: [],
            dataState: initialDataState,
            candidateId: "",
            showLoader: true,
            isVendorRole: this.userObj.roleType == AuthRoleType.Vendor,
            isClientRole: this.userObj.roleType == AuthRoleType.Client,

        };
    }

    componentDidMount() {
        this.setState({ candidateId: this.props.candidateId });
        this.getCandidateOwnership(this.state.dataState, this.props.candidateId);
    }

    getCandidateOwnership(dataState, candidateId: string) {
        this.setState({ showLoader: true });
        var queryStr = `${toODataString(dataState, { utcDates: true })}`;

        var queryParams = `candidateId eq ${candidateId}`;

        var vendorId = auth.getVendor();
        var clientId = auth.getClient();
        if (this.state.isVendorRole && vendorId)
            queryParams += ` and submittedVendorId eq ${vendorId}`;
        if (this.state.isClientRole && clientId) {
            queryParams += ` and clientId eq ${clientId}`;
        }

        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);

     
        axios.get(`api/candidates/ownership?${finalQueryString}`).then((res) => {
            this.setState({
                data: res.data,
                showLoader: false
            });
            this.getCandidateOwnershipCount(dataState, candidateId);
        });
    }

    onDataStateChange = (changeEvent) => {
        this.setState({ dataState: changeEvent.dataState });
        this.getCandidateOwnership(changeEvent.dataState, this.state.candidateId);
    };

    selectionChange = (event) => {
        const data = this.state.data.map((item) => {
            if (item.reqId === event.dataItem.reqId) {
                item.selected = !event.dataItem.selected;
            }
            return item;
        });
        this.setState({ data });
    };
    headerSelectionChange = (event) => {
        const checked = event.syntheticEvent.target.checked;
        const data = this.state.data.map((item) => {
            item.selected = checked;
            return item;
        });
        this.setState({ data });
    };
    getCandidateOwnershipCount = (dataState, candidateId: string) => {
        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
        };

        var vendorId = auth.getVendor();
        var clientId = auth.getClient();

        var queryStr = `${toODataString(finalState, { utcDates: true })}`;
        var queryParams = `candidateId eq ${candidateId}`;
        if (this.state.isVendorRole && vendorId)
            queryParams += ` and submittedVendorId eq ${vendorId}`;
        if (this.state.isClientRole && clientId) {
            queryParams += ` and clientId eq ${clientId}`;
        }
        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);
        

        axios.get(`api/candidates/ownership?${finalQueryString}`).then((res: any) => {
            this.setState({
                totalCount: res.data.length,
                totalCandidate: res.data
            });
        });
    };

    handleActionClick = (action, actionId, rowId, nextStateId?, eventName?, dataItem?) => {
        let change = {};
        let property = `show${action.replace(/ +/g, "").replace(".", "")}Modal`;
        change[property] = true;
        this.setState(change);
    }

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="myOrderContainer gridshadow ">
                        <div className="row mt-2 mb-2 mt-lg-3 mb-lg-3">
                            <Grid
                                sortable={true}
                                onDataStateChange={this.onDataStateChange}
                                pageable={true}
                                pageSize={5}
                                data={this.state.data}
                                {...this.state.dataState}
                                expandField="expanded"
                                total={this.state.totalCount}
                                className="kendo-grid-custom k-widget lastchild col-12 k-grid-table-candidate heighty_formobile font-weight-normal global-action-grid-onlyhead"
                                selectedField="selected"
                            // {/*    onSelectionChange={this.selectionChange}*/}
                            // {/*    onHeaderSelectionChange={this.headerSelectionChange}*/}
                            >
                                <GridNoRecords>{GridNoRecord(this.state.showLoader)}</GridNoRecords>
                                <GridColumn
                                    field="clientName"
                                    width="120px"
                                    title="Client"
                                    cell={(props) => CellRender(props, "Client")}
                                    columnMenu={ColumnMenu}
                                //headerClassName= {this.isColumnActive("reqNo", this.state.dataState)? "active-filter": ""}
                                />
                                <GridColumn
                                    field="submittedVendorName"
                                    title="Vendor"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Vendor")}
                                />
                                <GridColumn
                                    field="locations"
                                    title="Location"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => (
                                        props.dataItem.locations == null
                                            ? <td title="All">{'{All}'}</td>
                                            : <td title={props.dataItem.locations}>
                                                {props.dataItem.locations.length > 0 ? props.dataItem.locations : "-"}
                                            </td>
                                    )}
                                />
                                <GridColumn
                                    field="ownershipType"
                                    title="Ownership Type"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Ownership Type")}
                                />
                                <GridColumn
                                    field="ownershipDate"
                                    title="Ownership Date"
                                    filter="date"
                                    format="{0:d}"
                                    editor="date"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Ownership Date")}
                                />
                                <GridColumn
                                    field="ownershipDays"
                                    filter="numeric"
                                    title="Days"
                                    columnMenu={ColumnMenu}
                                    sortable={true}
                                    cell={(props) => NumberCell(props, "Days")}
                                />
                                <GridColumn
                                    field="expirationDate"
                                    filter="date"
                                    format="{0:d}"
                                    editor="date"
                                    title="Expiration"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Expiration")}
                                />
                                <GridColumn
                                    field="daysRemaining"
                                    filter="numeric"
                                    title="Remaining"
                                    columnMenu={ColumnMenu}
                                    sortable={true}
                                    cell={(props) => NumberCell(props, "Remaining")}
                                />
                                <GridColumn
                                    field="requestedBy"
                                    title="Requested By"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Requested By")}
                                />
                                <GridColumn
                                    field="requestedOn"
                                    format="{0:d}"
                                    filter="date"
                                    title="Requested On"
                                    editor="date"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Requested On")}
                                />
                                <GridColumn
                                    field="actionBy"
                                    title="Approved By"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Approved By")}
                                />
                                <GridColumn
                                    field="actionDate"
                                    title="Approved On"
                                    filter="date"
                                    format="{0:d}"
                                    editor="date"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Approved On")}
                                />
                                <GridColumn
                                    field="status"
                                    title="Status"
                                    columnMenu={ColumnMenu}
                                    cell={StatusCell}
                                />
                                <GridColumn
                                    title="Action"
                                    sortable={false}
                                    width="70px"
                                    headerCell={() => CustomMenu(this.state,this.props.candidateId)}
                                    cell={(props) => (
                                        <RowActions
                                            dataItem={props.dataItem}
                                            currentState={""}
                                            rowId={props.dataItem.candId}
                                            handleClick={this.handleActionClick}
                                            defaultActions={DefaultActions(props, props.dataItem.candShareRequestId)}
                                        />
                                    )}
                                />
                            </Grid>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
export default CandidateOwnershipWithShare;







